import { IMeal } from "../types/types"
import { MealForm } from "./MealForm"
import { BottomSheet } from "./BottomSheet"

export const MealEdit = ({ isOpen, handleClose, handleOpen, meal }: { isOpen: boolean, handleClose: () => void, handleOpen: () => void, meal?: IMeal }) => {
  return (
    <BottomSheet isOpen={isOpen} handleClose={handleClose} handleOpen={handleOpen}>
      <MealForm editingMeal={meal} onSuccess={handleClose} />
    </BottomSheet>
  )
}
